import { reactive } from 'vue';

const state = reactive({
  isOpen: false,
  title: '',
  message: '',
  resolve: null as ((value: boolean) => void) | null,
});

export function useConfirm() {
  const open = (title: string, message: string): Promise<boolean> => {
    state.title = title;
    state.message = message;
    state.isOpen = true;
    return new Promise((resolve) => {
      state.resolve = resolve;
    });
  };

  const confirm = () => {
    state.isOpen = false;
    state.resolve?.(true);
    state.resolve = null;
  };

  const cancel = () => {
    state.isOpen = false;
    state.resolve?.(false);
    state.resolve = null;
  };

  return { state, open, confirm, cancel };
}
